<template>
  <v-card>
    <v-toolbar card dense color="transparent">
      <v-toolbar-title>
        <h4>CATALOGO DEL PRODUCTO</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        dark
        fab
        small
        icon
        @click="abrirDialogNuevoCatalogo"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <template>
        <v-data-table
          :headers="headers"
          :items="listaCatalogoProducto"
          hide-actions
          class="elevation-0"
          :loading="loadingCatalogo"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.sku }}</td>
            <td class="text-lg-center">{{ props.item.descripcionTalla }}</td>
            <td class="text-lg-center">
              <v-icon :color="props.item.codigoHtml" medium>widgets</v-icon>
            </td>
            <td class="text-lg-center">
              <b>$ {{ formatMoney(props.item.precioVenta) }}</b>
            </td>
            <td class="text-lg-center">
              <b>$ {{ formatMoney(props.item.precioRenta) }}</b>
            </td>
            <td class="text-xs-right">
              <v-btn
                flat
                icon
                color="grey"
                @click="getProductoCatalogo(props.item.catalogoRowId)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                flat
                icon
                color="grey"
                :loading="$store.state.loadingDelete.show"
                @click="deleteProductoCatalogo(props.item.catalogoRowId)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </template>
      <v-divider></v-divider>
    </v-card-text>
    <form-catalogo-producto
      :catalogoProducto="catalogoProducto"
      :producto="producto"
      @onCatalogoProductoAdded="onCatalogoProductoAdded"
      @onCatalogoProductoUpdated="onCatalogoProductoUpdated"
      ref="dialogCatalogoProducto"
    ></form-catalogo-producto>
    <confirm ref="confirm"></confirm>
  </v-card>
</template>

<script>
//Components
import confirm from "@/components/dialogs/Confirm";
import formCatalogoProducto from "./FormCatalogoProducto";

//Sevices
import catalogoProductoService from "@/services/catalogoProductoService";

export default {
  components: {
    formCatalogoProducto,
    confirm,
  },
  props: {
    producto: {
      type: Object,
    },
  },
  watch: {
    producto: function (newProducto) {
      this.getListaCatalogoProducto();
      this.catalogoProducto.productoId = newProducto.productoId;
    },
  },
  data() {
    return {
      headers: [
        { text: "SKU / CODIGO", align: "center", sortable: true, value: "sku" },
        { text: "TALLA", align: "center", value: "descripcionTalla" },
        { text: "COLOR", align: "center", value: "codigoHtml" },
        { text: "PRECIO VENTA", align: "center", value: "precioVenta" },
        { text: "PRECIO RENTA", align: "center", value: "precioRenta" },
        { text: "ACCIONES", value: "acciones", align: "right" },
      ],
      listaCatalogoProducto: [],
      catalogoProducto: {
        catalogoRowId: 0,
        sku: "",
        productoId: this.producto.productoId,
        tallaId: 0,
        colorId: 0,
        precioVenta: 0,
        precioRenta: 0,
      },
      loadingCatalogo: false,
    };
  },
  mounted() {
    this.getListaCatalogoProducto();
  },
  methods: {
    getListaCatalogoProducto() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      catalogoProductoService
        .getAll(self.producto.productoId)
        .then((result) => {
          self.listaCatalogoProducto = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    getProductoCatalogo(catalogoRowId) {
      let self = this;

      self.$store.state.loadingInfo.show = true;
      catalogoProductoService
        .get(catalogoRowId)
        .then((result) => {
          self.$store.state.tituloForm = "MODIFICAR CATÁLOGO PRODUCTO";
          self.$store.state.iconoForm = "/images/general/actualizar-40.png";
          self.$refs.dialogCatalogoProducto.resetForm();
          self.catalogoProducto = result;
          self.$refs.dialogCatalogoProducto.openDialog();
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    abrirDialogNuevoCatalogo() {
      this.$store.state.tituloForm = "AGREGAR CATALOGO PRODUCTO";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogCatalogoProducto.resetForm();
      this.$refs.dialogCatalogoProducto.openDialog();
    },
    deleteProductoCatalogo(catalogoRowId) {
      let self = this;

      this.$refs.confirm
        .open(
          "ELIMINAR REGISTRO CATÁLOGO",
          "¿Estás seguro de eliminar el registro, se eliminará el inventario ligado a éste?",
          { color: "red" }
        )
        .then((confirm) => {
          if (confirm) {
            self.$store.state.loadingDelete.show = true;

            catalogoProductoService
              .delete(catalogoRowId)
              .then(() => {
                var i = this.listaCatalogoProducto.findIndex(
                  (obj) => obj.catalogoRowId == catalogoRowId
                );
                self.listaCatalogoProducto.splice(i, 1);

                self.$store.state.snackbar.color = "success";
                self.$store.state.snackbar.text =
                  "Registro eliminado con éxito";
                self.$store.state.snackbar.visible = true;

                ///Fire event
                self.$emit("onCatalogoProductoCrud");
              })
              .catch((e) => {
                self.operationFailed(e);
                console.log(e);
              })
              .finally(() => {
                self.$store.state.loadingDelete.show = false;
              });
          } else {
            self.$store.state.snackbar.color = "error";
            self.$store.state.snackbar.text = "Operación cancelada";
            self.$store.state.snackbar.visible = true;
          }
        });
    },
    onCatalogoProductoAdded(catalogoProducto) {
      this.listaCatalogoProducto.push(catalogoProducto);
      //Fire event
      this.$emit("onCatalogoProductoCrud");
    },
    onCatalogoProductoUpdated(catalogoProducto) {
      var i = this.listaCatalogoProducto.findIndex(
        (obj) => obj.catalogoRowId == catalogoProducto.catalogoRowId
      );
      this.listaCatalogoProducto.splice(i, 1, catalogoProducto);

      ///Fire event
      this.$emit("onCatalogoProductoCrud");
    },
  },
};
</script>
